<template>
  <li><hr class="dropdown-divider"></li>
</template>
